var _circle, _circle2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#39BAB5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    fill: "url(#social-media)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "social-media",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9485_83065",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9485_83065",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAEb0lEQVR4nO2dy48NQRSHT2NDSCRCPO7ITNjYmH+BlXhbsRGx9t5Zs7K18Ipn7NhhvHb8CWxIyPUMiceIwUS447OovnFnYuZ2VVd19b11vu3Mqa46p7ru6apfnxZRFEVRFEVRFCU1stgdqBPAShHZLiKbRWRQRBr5n96KyEsRGRGRG1mWvYnTwz4FWAGcA1p0ZwK4DgzG7ndfAOwAvhVw/FTGgG2x+9/TAIfzGe3KBHAo9jh6knzml3F+ZxD0TrABaOC27EzHGLDcpS+zfA+uRzguIvM9trdARI65GCaXhmJSzaaIzPbc9ISIDGZZ9tbGKMU7YIf4d77kbW63NUoxABsDtr3J1iDFAKwO2PYqW4MUA7A0YNsrbA1SDEBI/tgapBiA9wHbfmdrkFQAgJ0isjjgJZq2BkkEAFgD3BeRayKyMOClRgK23XsAi4DTFNtmLstvoNG9VwkAzAL2AB8qcHybs7HHXQuA9cDjCh0P8BVYFnvsUcHscF6t2PFgtqO3xh5/NIB5wDFgPJLzD8b2QTSAncArR+e1MD/Qe4FRB/uvwJbYPogCMAw8cHQ8ue1wR3sN4DLwq4Dtb8wBfnprPuXTyleYh7Hp2m9gzolvAc+B75iTsyfAbWAfKaaalE8rx4ETgM9TsDQA1gGPHB1PPpuHYo+j56B8WvkE2BB7HD0HMBc4irtqYRSzjs+JPZbKAVYCB4F7wFPMj9gPoAmMAEeAgRnsfaSVi6occy3ALBcXKZad/MKkfI0Oe69pZVLgrq0cxTwEBUsr+x7KaytdGcdsP8yL7YNo4E9baYumlfjXVhbhMbA+9thrAXCpQsenm1b+D0yqWcURXxJppcusCqWt7OShiBzOsuxR4Ov0HsDdgLP+C4mllS6ylJDayo9Zll0P2H7tcAlASG1lcoccdRNmEbsDVeMSAGv9owUhdZu1xCUA1vpHC5boj3B3bnvvxT8Wisg14CGp7m52AxhAH8TiAlyoIABtdCtiKpjiFmMVBgF0M24ywEaqWYqmotvRbYBD6IFMXIBtuC1HH4HdwBn0SLIcwHLgfEFH/sz/d1mH/TAm9XQl3UP5TjAnZfuBOxhh1DeMNOUZcAMjWZm2qgiwC3jtGARNW32ACrPqASpNrAeoODc+qDy9HmBe0AiWtmKWvSMYHWsTo2v9jtG53gMOMIO2NRnwoyVd29GezStKLcxemHVllL6D8mrqU5il7bODvdYNFanFa6paN1RkUtr6J0IQ9E5oQ5xSBc51Q/sS4hTrOB973LWDasvVtEjxHeIikBdsqiAI+2OPtdZg0tYvAQNgrRipmzIuKLnu9FPAS2jd0AJo3dA+RuuGFiCktlXrhhYgpLZV64YWIKS21bpuaIofcBgQkRfi/z23logM6QccupB/hO1KgKYv2jo/WfCvbdW6obbgT9uadt3QMlBe25p23VAf4K5tTbduqG+AxcBJTE3QIrP+Kp7W/OTS0JnA7Oe3P2c7JJM/Z9sU8wxxU7MdRVEURVEURVHK8BfPPIThbqVhYAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/social-media.5a3bda5bed734a6fcb22be4df10a9d25.svg";
export { ForwardRef as ReactComponent };